//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "",
    data(){
        return {
          delFlag:false,
        }
    },
    props:{
      volume:{
        type: String,
        default() { return ''}
      },
      payableAmount:{
        type: Number,
        default() { return 0}
      },
      datailsInfo:{
        type:Object,
        default (){ return {} }
      },
      detailInfo:{
        type:Object,
        default (){ return {} }
      }
    },
    created() {
      if(this.$route.query.templateFlag){
            this.templateFlag = this.$route.query.templateFlag;
      }
      // const tmplList = ['zh_tw','ta_tw']
      // if (this.payableAmount && tmplList.includes(this.templateFlag) && this.payableAmount!=this.datailsInfo.amountPrice  ) {

      if (this.payableAmount && this.payableAmount!=this.datailsInfo.amountPrice  ) {
        this.delFlag = true
      }

    },
    mounted() {

    }
}
